import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { exportInventoryOptions } from '../constants'

const ExportInventorySelector = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      value={value}
      handleChange={event => onChange(event.target.value)}
      menuItems={exportInventoryOptions.map(option => ({ label: t(option.label), value: option.value }))}
      fullWidth
    />
  )
}

export default ExportInventorySelector
